<template>
  <div id="contenedor-eliminar-status-contrato">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Estatus Contrato </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el estatus de contrato "{{contratoEstatusEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarEstatusContrato"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratoEstatus from './mixContratoEstatus';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarContratoEstatus',
  mixins: [mixContratoEstatus],
  props: {
    contratoEstatusEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
